import { SupportCard } from '@/components/features/Support/SupportCard';
import { SupportForm } from '@/components/features/Support/SupportForm';
import { SupportHeader } from '@/components/features/Support/SupportHeader';
import { telegram } from '@/config/social-media';
import { routes } from '@/utils/routes';
import { Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { BookIcon, HelpIcon, MailIcon, RocketIcon, SendIcon } from '@sphere/icons';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';

const Page = () => {
  const { t } = useTranslation('support');

  return (
    <>
      <NextSeo title={t('page-title')} description={t('page-description')} />
      <SupportHeader />
      <Container variant="breakout" pt={{ base: 'space.40', lg: 'space.120' }}>
        <SimpleGrid
          columns={{ base: 1, lg: 3 }}
          gap={{ base: 'space.16', lg: 'space.32' }}
          mb={{ base: 'space.80', lg: 'space.160' }}
        >
          <SupportCard
            href={routes.external.docs}
            title={t('links.docs.title')}
            icon={<BookIcon boxSize={{ base: rem(40), lg: rem(64) }} />}
          >
            <Text color="white">{t('links.docs.description')}</Text>
          </SupportCard>
          <SupportCard
            href={routes.external.helpCenter}
            title={t('links.help-center.title')}
            icon={<HelpIcon boxSize={{ base: rem(40), lg: rem(64) }} />}
          >
            <Text color="white">{t('links.help-center.description')}</Text>
          </SupportCard>
          <SupportCard
            href={routes.external.collectionDocs}
            title={t('links.mint.title')}
            icon={<RocketIcon boxSize={{ base: rem(40), lg: rem(64) }} />}
          >
            <Text color="white">{t('links.mint.description')}</Text>
          </SupportCard>
        </SimpleGrid>
        <Heading
          as="h2"
          fontSize={{ base: 'md', lg: '2xl' }}
          fontWeight="medium"
          mb={{ base: 'space.24', lg: 'space.40' }}
        >
          {t('support.title')}
        </Heading>
        <SimpleGrid
          columns={{ base: 1, lg: 3 }}
          gap={{ base: 'space.16', lg: 'space.32' }}
          mb={{ base: 'space.80', lg: 'space.160' }}
        >
          <SupportCard
            href={telegram.url}
            title={t('support.links.telegram.title')}
            icon={<SendIcon boxSize={{ base: rem(40), lg: rem(64) }} />}
          >
            <Text color="primary">{telegram.name}</Text>
          </SupportCard>
          <SupportCard
            href={routes.external.request}
            title={t('support.links.request.title')}
            icon={<MailIcon boxSize={{ base: rem(40), lg: rem(64) }} />}
          >
            <Text color="white">{t('support.links.request.description')}</Text>
          </SupportCard>
        </SimpleGrid>
        <SupportForm />
      </Container>
    </>
  );
};

export default Page;
